import { point } from "leaflet";
import { useCallback } from "react";

import { useMapContext } from "context/MapContextProvider";

const useShiftMap = () => {
  const { mapRef } = useMapContext();

  const shiftMapPointDetails = useCallback(
    (coordinates) => {
      const detailsWindow = document.querySelector("#pointDetails");

      const detailsWindowRect = detailsWindow.getBoundingClientRect();

      const distance = detailsWindowRect.right + window.scrollX;

      const screenWidthInPixels = distance / 2;

      const centerPoint = mapRef.current.latLngToContainerPoint(coordinates);
      const newPoint = point([
        centerPoint.x - screenWidthInPixels,
        centerPoint.y
      ]);
      const newLatLng = mapRef.current.containerPointToLatLng(newPoint);

      mapRef.current.panTo(newLatLng);
    },
    [mapRef]
  );

  return { shiftMapPointDetails };
};

export default useShiftMap;
